import MouseFollower from 'mouse-follower'
import gsap from 'gsap'

MouseFollower.registerGSAP(gsap)

const initCursor = () => {
  const cursor = new MouseFollower({
    speed: 0.55,
    ease: 'expo.out',
    skewing: 0,
    skewingText: 0.5,
    skewingIcon: 0,
    skewingMedia: 0,
    skewingDelta: 0.001,
    skewingDeltaMax: 0.15,
    iconSvgSrc: './dist/svg/icon-sprite.svg',
    iconSvgClassName: 'my-spritesheet',
    iconSvgNamePrefix: '-'
  })
}

export const resetCursorClasses = () => {
  const cursor = document.querySelector('.mf-cursor')
  cursor.removeAttribute('class')
  cursor.classList.add('mf-cursor')
}

export default initCursor
